import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n';
import useFlags from '@/hooks/useFlags';
import Modal from '../../common/Modal';
import printSvg from '../../../../images/icons/print.svg';
import styles from './PrintModal.module.scss';

PrintModal.propTypes = {
  asyncUrl: PropTypes.string,
  closeModal: PropTypes.func.isRequired,
  headerText: PropTypes.string.isRequired,
  modalIsOpen: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired
};

export default function PrintModal({
  asyncUrl, closeModal, headerText, modalIsOpen, url
}) {
  const { asyncFileGeneration } = useFlags();

  const handleClick = (language) => {
    const locale = language === 'Spanish' ? '&locale=es' : '';
    const targetUrl = asyncFileGeneration && asyncUrl ? asyncUrl : url;
    window.open(targetUrl + locale, '_blank');
    closeModal();
  };

  const renderLanguageOption = language => (
    <button
      className={styles.languageButton}
      type="button"
      onClick={() => handleClick(language)}
    >
      <img alt="" className={styles.printIcon} src={printSvg} />
      {language}
    </button>
  );

  const renderFooter = () => (
    <div className={styles.footer}>
      <button
        className="btn btn--link-purple"
        type="button"
        onClick={closeModal}
      >
        Cancel
      </button>
    </div>
  );

  return (
    <Modal
      className={styles.modal}
      closeModal={closeModal}
      headerText={headerText}
      isOpen={modalIsOpen}
    >
      <div className={styles.content}>
        <div className={styles.warningBox}>
          <i aria-hidden="true" className="fa fa-exclamation-triangle" />
          <span className={styles.warningText}>
            {I18n.t('warning_message')}
          </span>
        </div>
        <div className={styles.languageOptionsContainer}>
          {renderLanguageOption('English')}
          {renderLanguageOption('Spanish')}
        </div>
      </div>
      <hr />
      {renderFooter()}
    </Modal>
  );
}
